module.exports = __webpack_public_path__ + "static/media/share-registrar.ba24bdb2.svg";